// extracted by mini-css-extract-plugin
var _1 = "UserEditAddressFormModalFlatTagList-moduleUserEditAddressFormModalFlatTagList__obEh2";
var _2 = "UserEditAddressFormModalFlatTagList-moduletag__SNXTy Tag-moduleTag__FLr9H";
export { _1 as "UserEditAddressFormModalFlatTagList", _2 as "tag" }
